import React from "react";
import { Loader2 } from "lucide-react";
import useCountdown from "../hooks/useCountdown";

/**
 * Button content while a submit is in flight: "Submitting… 7s", then
 * "Almost done…" once the estimate runs out (the request is never cut off).
 */
const SubmitCountdown = ({
  active = true,
  label = "Submitting",
  seconds = 10,
  iconClassName = "w-4 h-4",
}) => {
  const remaining = useCountdown(active, seconds);

  return (
    <>
      <Loader2 className={`${iconClassName} animate-spin`} />
      <span aria-live="polite">
        {remaining > 0 ? (
          <>
            {label}…{" "}
            <span className="tabular-nums">{remaining}s</span>
          </>
        ) : (
          "Almost done…"
        )}
      </span>
    </>
  );
};

export default SubmitCountdown;
